import*as r from"react";import{CaretRight as t}from"@phosphor-icons/react";const e={defaultProps:{separator:r.createElement(t,null)}};export{e as default};
